export const parseValue = (
  value: any,
  valueType?: undefined | string | 'integer' | 'float' | 'boolean',
  defaultValue: any = '',
): any => {
  if (value) {
    if (valueType === 'integer') {
      return parseInt(value);
    }
    if (valueType === 'float') {
      return parseFloat(value);
    }
    if (valueType === 'boolean') {
      return ['true', 'yes', '1', true].includes(value)
        ? true
        : ['false', 'no', '0', false].includes(value)
        ? false
        : defaultValue;
    }
    return value;
  }
  return defaultValue;
};

/**
 * Assumes string are in ISO 8601 format
 */
export const parseDate = (date: string | Date, asLocal = false): Date => {
  const currentYear = new Date().getFullYear();
  const minValidYear = 1900; // Minimum reasonable year for business applications
  const maxValidYear = currentYear + 50; // Allow some future dates

  if (date instanceof Date) {
    const year = date.getFullYear();
    // Reject dates with clearly invalid years
    if (year < minValidYear || year > maxValidYear) {
      return new Date(NaN);
    }
    return new Date(date.toISOString());
  }

  let innerDate = date.trim();

  // Handle manual date input - validate year is reasonable
  // Look for patterns like MM/DD/YYYY or DD/MM/YYYY
  const datePattern = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/;
  const match = innerDate.match(datePattern);
  if (match) {
    const [, month, day, year] = match;
    const yearNum = parseInt(year, 10);

    // Reject years that are clearly invalid (like 0052, 0098, etc.)
    if (yearNum < minValidYear || yearNum > maxValidYear) {
      return new Date(NaN);
    }

    // Reconstruct the date string with validated year
    innerDate = `${yearNum}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  if (innerDate.length === 10) {
    innerDate = `${innerDate}T00:00:00`;
  }

  if (innerDate.length === 19) {
    if (asLocal) {
      const parts = innerDate.split(/[^0-9]/).map(s => parseInt(s, 10));

      // Validate year is reasonable
      if (parts[0] < minValidYear || parts[0] > maxValidYear) {
        return new Date(NaN);
      }

      return new Date(parts[0], parts[1] - 1 || 0, parts[2] || 1, parts[3] || 0, parts[4] || 0, parts[5] || 0);
    }
    innerDate = `${innerDate}Z`;
  }

  const parsedDate = new Date(innerDate);

  const year = parsedDate.getFullYear();
  if (isNaN(parsedDate.getTime())) {
    return new Date(NaN);
  }

  // Final validation: reject dates with unreasonable years
  if (year < minValidYear || year > maxValidYear) {
    return new Date(NaN);
  }

  return parsedDate;
};
